import React, {useContext, useEffect, useState} from 'react';
import { useNavigate } from "react-router-dom";
import { InputContext } from '../../contexts/InputContext';
import resourcesServices from '../../services/resourcesServices';
import TextControl from '../customizedInputs/TextControl';
import TextAreaControl from '../customizedInputs/TextAreaControl';
import { PDFDocument, EncryptedPDFError } from 'pdf-lib';
import { errorMessage } from '../../errorHandler';
import BotonVolver from '../BotonVolver';

const RegistroPdfFormPartial = ({id, cerrarModal, esModal=true}) => {
  let fileReader;
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  const [formularioPDF, setFormularioPDF] = useState({});
  const [esNuevo, setEsNuevo] = useState(true);

  useEffect(() => {
    setEsNuevo( id === undefined )
    if(id){
      obtenerFormularioPDF(id)
    } else {
      buscarFormularioPDF()
    }
  }, [id]);

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true && authInformation.rol === 'Admin'){
      setRenderHTML(true)
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);


  const obtenerFormularioPDF = async (id) => {
    try {
      const data = await resourcesServices.obtenerResourcePorId('formulario_pdfs', id);
      setFormularioPDF(data);

    } catch (error) {
      errorMessage(error)
    }
  };

  const buscarFormularioPDF = async () => {
    try {
      const data = await resourcesServices.obtenerResources('formulario_pdfs');
      if( data.data.length > 0 ) {
        navigate(`/registroPdfForm/${data.data[0].id}`);
      } else {
        nuevoFormularioPDF();
      }
    } catch (error) {
      errorMessage(error)
    }
  };

  const nuevoFormularioPDF = async () => {
    try {
      const data = await resourcesServices.nuevoResource('formulario_pdfs');
      setFormularioPDF(data);
    } catch (error) {
      errorMessage(error)
    }
  };

  const guardarUsuario = async () => {
    try {
      let data;

      const copiaFormularioPDF = {...formularioPDF}
      copiaFormularioPDF.campos_formulario_pdfs_attributes = copiaFormularioPDF.campos_formulario_pdfs

      // const attributeName = 'notiformulario_pdfsficacion'

      // const formData =  new FormData();
      // for(const [key, value] of Object.entries(copiaFormularioPDF)){
      //   if(value){
      //     formData.append(`${attributeName}[${key}]`, value)
      //   }
      // }

      if(esNuevo){
        data = await resourcesServices.crearResource('formulario_pdfs', {formulario_pdf: copiaFormularioPDF});
      } else {
        data = await resourcesServices.actualizarResource('formulario_pdfs', copiaFormularioPDF.id, {formulario_pdf: copiaFormularioPDF});
      }


      setFormularioPDF(data);
      if(esModal){
        cerrarModal()
      } else {
        window.alert("Información actualizada")
        if(esNuevo){
          navigate(`/registroPdfForm/${data.id}`);
        }
      }


    } catch (error) {
      errorMessage(error)
    }
  };

  const handleInputNested = (e, index) => {
    const { name, value } = e.target;
    const [parentKey, childKey] = name.split('.');

    let copiaFormularioPDF = {...formularioPDF}
    if(childKey === 'visible') {
      copiaFormularioPDF.campos_formulario_pdfs[index][childKey] =  !copiaFormularioPDF.campos_formulario_pdfs[index][childKey]
    } else {
      copiaFormularioPDF.campos_formulario_pdfs[index][childKey] =  value
    }

    setFormularioPDF({...formularioPDF,
      ['campos_formulario_pdfs']: copiaFormularioPDF.campos_formulario_pdfs
    })
  }

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormularioPDF({...formularioPDF,
      [name]: value
    })
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()
    guardarUsuario()
  }

  const handleFileReader = async (e) => {
    try {
      alert("Entro")
      const pdfDoc = await PDFDocument.load(fileReader.result, { ignoreEncryption: true });

      const form = pdfDoc.getForm();
      const fields = form.getFields();
      const campos_formulario_pdfs = [];

      fields.forEach(field => {
        const name = field.getName();
        const value = field.getText();
        campos_formulario_pdfs.push({
          nombre_pdf: name,
          nombre_web: value,
          descripcion: "",
          visible: true,
        })

      })

      setFormularioPDF({...formularioPDF,
        ['campos_formulario_pdfs']: campos_formulario_pdfs
      })

    } catch (error) {
      alert(error)
    }
  }

  const eliminarFormulario = async () => {
    try {
      if(!window.confirm('Está seguro que quiere eliminar el formulario?')){
        return;
      }

      await resourcesServices.eliminarResource('formulario_pdfs', formularioPDF.id);
      window.alert("Eliminado")

      if(esModal){
        cerrarModal()
      } else {
        navigate(`/registroPdfForm`);
      }

    } catch (error) {
      errorMessage(error)
    }
  }

  useEffect(() => {
    if(formularioPDF.adjunto){

      fileReader = new FileReader();
      fileReader.readAsArrayBuffer(formularioPDF.adjunto)
      fileReader.onloadend = handleFileReader;
    }

  }, [formularioPDF.adjunto]);

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormularioPDF({...formularioPDF,
      [name]: files[0]
    })
  };

  return (
    <div>
      {renderHTML && (
        <>
        <h1>Formulario de inscripción <BotonVolver /></h1>

        <div className="card">
          {/* <pre>{JSON.stringify(formularioPDF, null, 2)}</pre> */}
          <div className="card-body px-0 pb-2 ms-3 me-3">
            <form onSubmit={handleFormSubmit}>

              <TextControl
                value={formularioPDF.nombre}
                name={'nombre'}
                handleInput={handleInput}
                />

              <TextAreaControl
                value={formularioPDF.descripcion}
                name={'descripcion'}
                height={'150px'}
                handleInput={handleInput}
                />

              <div className="card mb-3">
                <div className="card-body">
                  <div className="mb-3">
                    <input
                      placeholder="Adjunte el documento interactivo"
                      className="form-control"
                      onChange={handleFileChange}
                      accept='.pdf'
                      name="adjunto"
                      type="file"
                      id="adjunto" />
                  </div>
                  {
                    formularioPDF.archivoUrl && (
                      <a href={formularioPDF.archivoUrl} className='btn btn-success' target='_blank'>Ver Archivo</a>
                    )
                  }
                </div>
              </div>


              <div className="card mb-3" >
                <div className="card-body p-2">
              {
                formularioPDF.campos_formulario_pdfs && formularioPDF.campos_formulario_pdfs.map((pdf, index) => (
                  <div className="row align-items-center" key={index}>
                    <div className='col-2 text-end'>
                      {pdf.nombre_pdf}
                    </div>
                    <div className='col'>
                      <TextControl
                        value={pdf.nombre_web}
                        name={`campos_formulario_pdfs.nombre_web`}
                        handleInput={(e)=>handleInputNested(e, index)}
                        />
                    </div>
                    <div className='col'>
                      <TextControl
                        value={pdf.descripcion}
                        name={`campos_formulario_pdfs.descripcion`}
                        handleInput={(e)=>handleInputNested(e, index)}
                        />
                    </div>
                    <div className='col-3'>
                      <div className='form-check form-switch'>
                        <input className='form-check-input' name={`campos_formulario_pdfs.visible`} checked={pdf.visible} onChange={(e)=>handleInputNested(e, index)} type='checkbox' role="switch" id={`switch_${index}`} />
                        <label className='form-check-label' htmlFor={`switch_${index}`} >Visible</label>
                      </div>
                    </div>
                    {/* <div className='col-3'>
                      <div className='form-check'>
                        <input className='form-check-input' name={`campos_formulario_pdfs.visible`} checked={pdf.visible} onChange={(e)=>handleInputNested(e, index)} type='checkbox' id={`switch_${index}`} />
                        <label className='custom-control-label' htmlFor={`switch_${index}`} >Visible</label>
                      </div>
                    </div> */}
                  </div>
                ))
              }
                </div>
              </div>
              {
                !esModal && (
                  <>
                  <button className="btn btn-primary mt-3" type="submit">Guardar</button>
                  {
                    !esNuevo && (
                      <button className="btn btn-danger ms-3 mt-3" onClick={() => eliminarFormulario()} type="button">Eliminar</button>
                    )
                  }
                  </>
                )
              }
              </form>
          </div>
        </div>
        </>

      )}
    </div>
  );
};

export default RegistroPdfFormPartial;